import clsx from 'clsx';
import { ChangeEvent, useState } from 'react';

export type TextAreaProps = {
  name: string;
  placeholder?: string;
  value: number | string;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  disabled?: boolean;
  error?: boolean;
  width: string;
  label?: string;
  limit?: number;
  counter?: boolean;
};

const TextArea = ({
  name,
  placeholder,
  value,
  onChange,
  disabled,
  limit = 500,
  counter = false,
  error,
  label,
  width,
}: TextAreaProps): JSX.Element => {
  const [count, setCount] = useState(0);
  return (
    <label className={clsx('relative', width)} data-testid="textarea-container">
      {label && <p className="mb-1">{label}</p>}
      <textarea
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={e => {
          onChange(e);
          setCount(e.target.value.length);
        }}
        disabled={disabled}
        aria-invalid={error}
        maxLength={limit}
        aria-label={name}
        data-testid="textArea"
        className={clsx(
          'rounded-md border-2 px-4 py-2',
          width,
          { 'opacity-40': disabled },
          { 'border-main-content-3': !error },
          { 'border-error-border': error }
        )}
      />
      {counter && (
        <span className="absolute right-3 -bottom-6">
          {count} / {limit}
        </span>
      )}
    </label>
  );
};

export default TextArea;
